import type React from 'react';

import { useTranslation } from 'react-i18next';

import TMXDialog, { type TMXDialogProps, TMXDialogTitle } from 'components/dialogs/TMXDialog';
import { BodyRegular, H3 } from 'components/typography/Typography';
import { type FlightProfile } from 'typedefs/store/tmxTypes';

import SelectDrawsForm from './SelectDrawsForm';
import { useStyles } from './styles';

interface RemoveFromDrawDialogProps extends TMXDialogProps {
  onSave?: (selectedDraws: string[]) => Promise<void>;
  loading?: boolean;
  flights?: FlightProfile[];
  selectedEntriesIds?: string[];
}

const RemoveDialogTitle: React.FC<React.PropsWithChildren<{ entriesCount?: number }>> = ({ entriesCount }) => {
  const { t } = useTranslation();
  return (
    <TMXDialogTitle>
      <H3>{t('removeFromDraw')}</H3>
      <BodyRegular>{t('splitDraws.removeParticipantsFromDraw', { count: entriesCount })}</BodyRegular>
    </TMXDialogTitle>
  );
};

const RemoveFromDrawDialog: React.FC<React.PropsWithChildren<RemoveFromDrawDialogProps>> = ({
  onSave,
  loading,
  flights,
  selectedEntriesIds,
  ...props
}) => {
  const { classes } = useStyles();
  const handleSubmit = (values) => onSave?.(values.selectedDraws);

  return (
    <TMXDialog
      {...props}
      className={classes.tmxDialog}
      PaperProps={{
        className: classes.tmxDialogPaper,
      }}
    >
      <SelectDrawsForm
        isRemoving
        flights={flights}
        loading={loading}
        selectedIds={selectedEntriesIds}
        title={<RemoveDialogTitle entriesCount={selectedEntriesIds?.length} />}
        onClose={(e) => props?.onClose(e, 'escapeKeyDown')}
        onSubmit={handleSubmit}
      />
    </TMXDialog>
  );
};

export default RemoveFromDrawDialog;
